import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { PasswordInput } from "@/components/PasswordInput";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";

export default function ChangePasswordDialog({ className = "" }) {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [cur, setCur] = useState("");
  const [nw, setNw] = useState("");
  const [cf, setCf] = useState("");
  const [busy, setBusy] = useState(false);

  if (user?.auth_provider && user.auth_provider !== "password") return null;

  const submit = async (e) => {
    e.preventDefault();
    if (nw.length < 6) return toast.error("La nuova password deve avere almeno 6 caratteri");
    if (nw !== cf) return toast.error("Le due password non coincidono");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: nw });
      toast.success("Password aggiornata");
      setOpen(false); setCur(""); setNw(""); setCf("");
    } catch (err) { toast.error(apiError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <>
      <Button data-testid="open-change-password" size="sm" variant="ghost" onClick={() => setOpen(true)} className={className}>
        <KeyRound size={15} className="sm:mr-1.5" /> <span className="hidden sm:inline">Password</span>
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-sm" data-testid="change-password-dialog">
          <DialogHeader><DialogTitle>Cambia password</DialogTitle></DialogHeader>
          <form onSubmit={submit} className="space-y-3">
            <div><Label className="text-xs">Password attuale</Label><PasswordInput data-testid="cp-current" required value={cur} onChange={(e) => setCur(e.target.value)} className="mt-1 bg-white" placeholder="La password attuale (o quella temporanea)" /></div>
            <div><Label className="text-xs">Nuova password</Label><PasswordInput data-testid="cp-new" required minLength={6} value={nw} onChange={(e) => setNw(e.target.value)} className="mt-1 bg-white" placeholder="Almeno 6 caratteri" /></div>
            <div><Label className="text-xs">Conferma nuova password</Label><PasswordInput data-testid="cp-confirm" required value={cf} onChange={(e) => setCf(e.target.value)} className="mt-1 bg-white" placeholder="Ripeti la nuova password" /></div>
            <DialogFooter>
              <Button type="button" variant="outline" onClick={() => setOpen(false)}>Annulla</Button>
              <Button type="submit" data-testid="cp-submit" disabled={busy} className="bg-primary text-primary-foreground hover:bg-primary/90">{busy ? "Salvo…" : "Aggiorna password"}</Button>
            </DialogFooter>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
}
